// Extracted from mailscore.testedgood.com/widget.js — pure function, no DOM deps.
var KNOWN_DOMAINS = [
  'gmail.com','googlemail.com',
  'yahoo.com','yahoo.co.uk','yahoo.com.au','yahoo.ca','yahoo.fr','yahoo.de','yahoo.es','yahoo.it','yahoo.in',
  'hotmail.com','hotmail.co.uk','hotmail.fr','hotmail.de','hotmail.es','hotmail.it','hotmail.com.au',
  'outlook.com','outlook.fr','outlook.de','outlook.es','outlook.it','outlook.com.au',
  'live.com','live.co.uk','msn.com',
  'icloud.com','me.com','mac.com',
  'protonmail.com','proton.me','pm.me',
  'aol.com','aol.co.uk','mail.com','zoho.com','gmx.com','gmx.de','gmx.net',
  'fastmail.com','yandex.com','yandex.ru','ymail.com','rocketmail.com','tutanota.com',
  'mail.ru','qq.com','163.com','126.com','sina.com','naver.com','hanmail.net','daum.net',
];

var PLACEHOLDERS = [
  'test','tests','testing','fake','temp','tmp','null','none','sample','example',
  'dummy','abc','xyz','asdf','qwerty','aaa','aaaa','nothing','anonymous','anon',
];

var VULGAR = [
  'fuck','fuk','fucker','fucking','shit','asshole','bitch','cunt',
  'dick','pussy','cock','slut','whore','nigger','faggot','retard',
];

var RE_LOCAL    = /^[a-z0-9._%+\-]+$/;
var RE_DOMAIN   = /^[a-z0-9.\-]+\.[a-z]{2,}$/;
var RE_REPEAT1  = /(.)\1{3,}/;
var RE_REPEAT2  = /(.{2})\1{2,}/;
var RE_REPEAT3  = /(.{3})\1{1,}/;
var RE_CONSON   = /[bcdfghjklmnpqrstvwxz]{5,}/;

var RE_ALLCAPS  = /^[A-Z0-9]+$/;
var RE_HASUPPER = /[A-Z]/;

var MSG_FAKE    = "This email doesn't look real. Please use your actual email address.";
var MSG_INVALID = 'Please enter a valid email address.';
var MSG_VULGAR  = 'Please use an appropriate email address.';

function fail(reason, message) {
  return { valid: false, reason: reason, message: message };
}

function lev(a, b) {
  if (a === b) return 0;
  var al = a.length, bl = b.length;
  if (Math.abs(al - bl) > 1) return 2;
  var prev = [], curr = [], i, j, rowMin;
  for (j = 0; j <= bl; j++) prev[j] = j;
  for (i = 1; i <= al; i++) {
    curr[0] = i; rowMin = i;
    for (j = 1; j <= bl; j++) {
      curr[j] = a.charCodeAt(i - 1) === b.charCodeAt(j - 1)
        ? prev[j - 1]
        : 1 + Math.min(prev[j - 1], prev[j], curr[j - 1]);
      if (curr[j] < rowMin) rowMin = curr[j];
    }
    if (rowMin > 1) return 2;
    var tmp = prev; prev = curr; curr = tmp;
  }
  return prev[bl];
}

function isAlphaSequence(s) {
  if (s.length < 3) return false;
  for (var i = 1; i < s.length; i++) {
    var c = s.charCodeAt(i);
    if (c < 97 || c > 122 || c !== s.charCodeAt(i - 1) + 1) return false;
  }
  return true;
}

export function checkEmail(input) {
  if (typeof input !== 'string') return fail('invalid_format', MSG_INVALID);
  var raw = input.trim();
  if (!raw) return fail('invalid_format', MSG_INVALID);

  var at = raw.indexOf('@');
  if (at < 1 || at === raw.length - 1 || raw.indexOf('@', at + 1) !== -1) {
    return fail('invalid_format', MSG_INVALID);
  }

  var localOrig = raw.substring(0, at);
  var local     = localOrig.toLowerCase();
  var domain    = raw.substring(at + 1).toLowerCase();

  if (!RE_LOCAL.test(local) || !RE_DOMAIN.test(domain)) {
    return fail('invalid_format', MSG_INVALID);
  }

  var exact = false;
  for (var i = 0; i < KNOWN_DOMAINS.length; i++) {
    if (KNOWN_DOMAINS[i] === domain) { exact = true; break; }
  }
  if (!exact) {
    for (i = 0; i < KNOWN_DOMAINS.length; i++) {
      if (lev(domain, KNOWN_DOMAINS[i]) === 1) {
        return fail('typo_domain', 'Did you mean @' + KNOWN_DOMAINS[i] + '?');
      }
    }
  }

  if (local === domain.split('.')[0]) return fail('placeholder', MSG_FAKE);

  for (i = 0; i < PLACEHOLDERS.length; i++) {
    if (local === PLACEHOLDERS[i]) return fail('placeholder', MSG_FAKE);
  }

  for (i = 0; i < VULGAR.length; i++) {
    if (local.indexOf(VULGAR[i]) !== -1) return fail('vulgar', MSG_VULGAR);
  }

  if (isAlphaSequence(local)) return fail('sequential', MSG_FAKE);

  if (local.length <= 2) return fail('too_short', MSG_FAKE);

  if (localOrig.length <= 4 && RE_ALLCAPS.test(localOrig) && RE_HASUPPER.test(localOrig)) {
    return fail('placeholder', MSG_FAKE);
  }

  if (RE_REPEAT1.test(local) || RE_REPEAT2.test(local) || RE_REPEAT3.test(local)) {
    return fail('repeated_pattern', MSG_FAKE);
  }

  if (RE_CONSON.test(local)) return fail('keyboard_mash', MSG_FAKE);

  var letters = local.replace(/[^a-z]/g, '');
  if (letters.length > 8) {
    var vowels = letters.replace(/[^aeiouy]/g, '').length;
    if (vowels / letters.length < 0.15) {
      return fail('low_vowel_ratio', MSG_FAKE);
    }
  }

  return { valid: true };
}
